// eslint-disable-next-line @atlaskit/design-system/use-spotlight-package
import Spotlight from '@atlaskit/onboarding/spotlight';

import { token } from '@atlaskit/tokens';

import { useIntl } from 'react-intl';

import { messages } from './messages';

import { type JSX } from 'react/jsx-runtime';

export const MoreActionsSpotlight = ({
	onFinish,
}: {
	onFinish: (isTourCompleted?: boolean) => void;
}): JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Spotlight
			actions={[
				{
					// eslint-disable-next-line @post-office/message-linting/require-instrumented-interactions -- HighImpactOnboarding.dismissMessage records onAcknowledged when onFinish receives true.
					onClick: () => onFinish(true),
					text: formatMessage(messages.okButton),
				},
			]}
			target="project-issue-navigator.ui.page-actions.meatball-menu"
			key="project-issue-navigator.ui.page-actions.meatball-menu"
			targetRadius={token('radius.medium', '3px')}
			dialogWidth={285}
			targetBgColor={token('elevation.surface')}
			actionsBeforeElement={<>2/2</>}
			testId="more-actions-spotlight"
			dialogPlacement="left top"
		>
			{formatMessage(messages.moreActionsSpotlightMessage)}
		</Spotlight>
	);
};
